import { useMutation } from '@tanstack/react-query';

import { queryClient } from '~app/query-client';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

import type { Performance } from '../model/recital';

export interface ReorderPerformanceParams {
  actId: string;
  performanceId: string;
  orderIndex: number;
}

export const reorderPerformanceAPI = async ({
  actId,
  performanceId,
  orderIndex,
}: ReorderPerformanceParams) => {
  const response = await baseAPI.patch<Performance>(
    `/acts/${actId}/performances/${performanceId}/reorder`,
    { orderIndex },
  );
  return response.data;
};

export const useReorderPerformanceMutation = () => {
  return useMutation({
    mutationFn: async (params: ReorderPerformanceParams) => {
      return await reorderPerformanceAPI(params);
    },
    onSuccess: (_, variables) => {
      void queryClient.invalidateQueries({
        queryKey: [KEYS.ACTS, variables.actId, KEYS.PERFORMANCES],
      });
    },
  });
};
